import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { capitalize } from "@utdanningsdirektoratet/utils/string";
import styles from "./Button.module.less";

interface LinkButtonProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "children"> {
  className?: string;
  href: string;
  active?: boolean;
  primary?: boolean;
  "data-tooltip"?: boolean;
  wrapped?: boolean;
  last?: boolean;
  naked?: boolean;
  disabled?: boolean;
  inline?: boolean;
  role?: React.AriaRole;
  color?: "green" | "red" | "white" | "vy";
  children?:
    | ((props: {
        className: string;
        href?: string;
        onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
        role: string;
        "aria-disabled": boolean;
      }) => React.ReactNode)
    | React.ReactNode;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  className,
  role = "link",
  href,
  disabled,
  naked,
  active,
  primary,
  wrapped,
  last,
  color,
  children,
  ...rest
}) => {
  const linkClass = cls(
    {
      [styles.button]: true,
      [styles.buttonLink]: true,
      [styles.buttonActive]: active,
      [styles.buttonPrimary]: primary,
      [styles.buttonDisabled]: disabled,
      [styles.buttonWrapped]: wrapped,
      [styles.buttonLast]: last,
      [styles.buttonNaked]: naked,
      [styles.buttonLinkDisabled]: disabled,
      [styles.buttonLinkNaked]: naked,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [styles[`button${capitalize(color)}`]]: color,
    },
    className
  );
  const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) event.preventDefault();
  };

  if (typeof children === "function") {
    return (
      <>
        {(children as (a: unknown) => React.ReactNode)({
          ...rest,
          className: linkClass,
          href,
          onClick: onClickHandler,
          role: "button",
          "aria-disabled": disabled,
        })}
      </>
    );
  }

  return (
    <a {...rest} href={href} aria-disabled={disabled} onClick={onClickHandler} role={role} className={linkClass}>
      {children}
    </a>
  );
};

export default LinkButton;
